
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherAllocateDetailsGrid extends Serenity.EntityGrid<GiftVoucherAllocateDetailsRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherAllocateDetails'; }
        protected getDialogType() { return GiftVoucherAllocateDetailsDialog; }
        protected getIdProperty() { return GiftVoucherAllocateDetailsRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherAllocateDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherAllocateDetailsRow.localTextPrefix; }
        protected getService() { return GiftVoucherAllocateDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}